import type { ComponentsOverrides, ComponentsVariants, ComponentsProps } from '@mui/material';

import type { Section_BaseFragmentFragment } from '@ias/graphql-sdk';
import { TextProps } from '../Text';
import { MediaProps } from '../Media';

import type { Theme } from '@mui/material/styles';

export enum SectionContentDirections {
  row = 'row',
  column = 'column'
}

export enum SectionVariants {
  default = 'default',
  onePerRow = 'onePerRow',
  twoPerRow = 'twoPerRow',
  threePerRow = 'three-per-row',
  twoColFiftyFifty = '2 col: fifty-fifty',
  twoColTwoThirds = '2 col: two-thirds',
  statementWithIcon = 'statement w/ icon',
  stacked = 'stacked'
}

export interface SectionProps
  extends Omit<Section_BaseFragmentFragment, 'variant' | 'contentDirection' | '__typename' | 'background'> {
  variant?: SectionVariants;
  contentDirection?: SectionContentDirections;
  testId?: string;
  introText?: TextProps;
  background?: MediaProps;
}

export interface SectionOwnerState extends SectionProps {}

interface SectionClasses {
  root: string;
  contentOuterGrid: string;
  contentWrap: string;
  contentInnerGrid: string;
  backgroundMediaWrap: string;
  backgroundMedia: string;
  introTextGrid: string;
  introText: string;
  itemsGrid: string;
  sectionItem: string;
}

export declare type SectionClassKey = keyof SectionClasses;

declare module '@mui/material' {
  export interface ComponentNameToClassKey {
    Section: SectionClassKey;
  }

  export interface ComponentsPropsList {
    Section: SectionProps;
  }
}

declare module '@mui/material' {
  interface Components {
    Section?: {
      defaultProps?: ComponentsProps['Section'];
      styleOverrides?: ComponentsOverrides<Theme>['Section'];
      variants?: ComponentsVariants['Section'];
    };
  }
}
